module.exports = __webpack_public_path__ + "img/image29.952b3565.jpg";